export default __webpack_public_path__ + "static/b4-1aac99f2624e06b50c10f8cc4346872d.png";